import { decimalsToWei } from '@akropolis-web/primitives';

import { getAmount } from 'domain/utils';

export const priceFormatter = (value: number) => {
  return getAmount(value, '$').mul(decimalsToWei(18)).toFormattedString();
};

export const xTickFormatter = (value: Date) => {
  const today = new Date().setHours(0, 0, 0, 0);
  return Intl.DateTimeFormat(
    'en-US',
    value.getTime() > today
      ? { hour: '2-digit', minute: '2-digit' }
      : {
          day: 'numeric',
          month: 'short',
          hour: '2-digit',
          minute: '2-digit',
        },
  ).format(value);
};
